<div class="title-padding" [ngClass]="{'title-grid-comp division-line border-b-1 border-solid': !isMobileSearchbarActive}">
  <div *ngIf="!isMobileSearchbarActive" class="title flex flex-row items-center ">
    <button  (click)="onBackClick()" class="flex justify-center items-center bg-transparent border-none h-fit">
      <mat-icon class="mdi mdi-chevron-left text-xl lg:text-[26px] leading-5 lg:leading-[26px] mr-3 font-bold mt-[2px]" [ngClass]="backIconClass ? backIconClass : ''"></mat-icon>
    </button>

    <!-- el icono debería tener la clase title-icon -->
    <ng-content select="[pageTitleIcon]"></ng-content>
    <ng-container *ngIf="showTooltip">
      <span class="overflow-text-cover-1"
       mat-raised-button
      [matTooltip]="title ? title : ''"
      matTooltipClass="default-angular-tooltip"
      matTooltipPosition="below"
      aria-label="shows tooltip"
      >{{title}}
      </span>

      <div *ngIf="subtitle" class="flex gap-3 items-center pr-4">
        <mat-icon class="mdi mdi-chevron-right text-xl lg:text-[26px] leading-5 lg:leading-[26px] font-bold mt-[2px]"></mat-icon>
        <span class="overflow-text-cover-1"
        mat-raised-button
        [matTooltip]="subtitle ? subtitle : ''"
        matTooltipClass="default-angular-tooltip"
        matTooltipPosition="below"
        aria-label="shows tooltip"
        >{{subtitle}}</span>
      </div>


    </ng-container>

    <ng-container *ngIf="!showTooltip">
      <span class="">{{title}} </span>



      <div *ngIf="subtitle" class="flex gap-3 items-center pr-4">
        <mat-icon class="mdi mdi-chevron-right text-xl lg:text-[26px] leading-5 lg:leading-[26px] font-bold mt-[2px]"></mat-icon>
        <span class="overflow-text-cover-1">{{subtitle}}</span>
      </div>
    </ng-container>

    <ng-content select="[pageTitleExtra]"></ng-content>

  </div>
  <div class="flex" [ngClass]="isMobileSearchbarActive ? 'w-full' : 'justify-end'">
    <!-- Buscar -->
    <ng-content select="[titleExtraComponent]"></ng-content>
  </div>
</div>
